var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 94 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_6774_1174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 97V69H23.2367C24.1216 69 24.9432 69.2333 25.7017 69.7C26.4601 70.1407 27.0542 70.75 27.484 71.5278C27.9391 72.2796 28.1666 73.1222 28.1666 74.0556V79.7722C28.1666 80.1093 28.1287 80.4463 28.0529 80.7833C28.0023 81.1204 27.9012 81.4315 27.7495 81.7167C28.2551 82.4426 28.6344 83.1296 28.8872 83.7778C29.1653 84.4 29.3043 85.0352 29.3043 85.6833V91.9444C29.3043 92.8778 29.0768 93.7333 28.6217 94.5111C28.1919 95.263 27.5978 95.8722 26.8394 96.3389C26.0809 96.7796 25.2466 97 24.3365 97H2ZM7.04372 92.8H24.2606C24.5134 92.8 24.7283 92.7093 24.9053 92.5278C25.0823 92.3204 25.1708 92.087 25.1708 91.8278V85.8C25.1708 85.5407 25.0823 85.3204 24.9053 85.1389C24.7283 84.9315 24.5134 84.8278 24.2606 84.8278H7.04372C6.7909 84.8278 6.56336 84.9315 6.36111 85.1389C6.18414 85.3204 6.09565 85.5407 6.09565 85.8V91.8278C6.09565 92.087 6.18414 92.3204 6.36111 92.5278C6.56336 92.7093 6.7909 92.8 7.04372 92.8ZM7.04372 80.6278H23.1229C23.3758 80.6278 23.5906 80.537 23.7676 80.3556C23.9446 80.1481 24.0331 79.9148 24.0331 79.6556V74.1722C24.0331 73.913 23.9446 73.6926 23.7676 73.5111C23.5906 73.3037 23.3758 73.2 23.1229 73.2H7.04372C6.7909 73.2 6.56336 73.3037 6.36111 73.5111C6.18414 73.6926 6.09565 73.913 6.09565 74.1722V79.6556C6.09565 79.9148 6.18414 80.1481 6.36111 80.3556C6.56336 80.537 6.7909 80.6278 7.04372 80.6278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2173 97C37.3325 97 36.5108 96.7796 35.7524 96.3389C34.9939 95.8722 34.3872 95.263 33.9321 94.5111C33.5023 93.7333 33.2874 92.8778 33.2874 91.9444V90.3111H37.383V91.8278C37.383 92.087 37.4715 92.3204 37.6485 92.5278C37.8508 92.7093 38.0783 92.8 38.3311 92.8H55.548C55.8008 92.8 56.0157 92.7093 56.1927 92.5278C56.3697 92.3204 56.4582 92.087 56.4582 91.8278V86.0722C56.4582 85.787 56.3697 85.5537 56.1927 85.3722C56.0157 85.1907 55.8008 85.1 55.548 85.1H38.2173C37.3325 85.1 36.5108 84.8796 35.7524 84.4389C34.9939 83.9722 34.3872 83.363 33.9321 82.6111C33.5023 81.8333 33.2874 80.9778 33.2874 80.0444V74.0556C33.2874 73.1222 33.5023 72.2796 33.9321 71.5278C34.3872 70.75 34.9939 70.1407 35.7524 69.7C36.5108 69.2333 37.3325 69 38.2173 69H55.6618C56.5466 69 57.3683 69.2333 58.1267 69.7C58.8852 70.1407 59.4793 70.75 59.9091 71.5278C60.3642 72.2796 60.5917 73.1222 60.5917 74.0556V75.6889H56.4582V74.1722C56.4582 73.913 56.3697 73.6926 56.1927 73.5111C56.0157 73.3037 55.8008 73.2 55.548 73.2H38.3311C38.0783 73.2 37.8508 73.3037 37.6485 73.5111C37.4715 73.6926 37.383 73.913 37.383 74.1722V79.9278C37.383 80.213 37.4715 80.4463 37.6485 80.6278C37.8508 80.8093 38.0783 80.9 38.3311 80.9H55.6618C56.5466 80.9 57.3683 81.1333 58.1267 81.6C58.8852 82.0407 59.4793 82.65 59.9091 83.4278C60.3642 84.1796 60.5917 85.0222 60.5917 85.9556V91.9444C60.5917 92.8778 60.3642 93.7333 59.9091 94.5111C59.4793 95.263 58.8852 95.8722 58.1267 96.3389C57.3683 96.7796 56.5466 97 55.6618 97H38.2173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6256 97C68.7155 97 67.8812 96.7796 67.1227 96.3389C66.3895 95.8722 65.7954 95.263 65.3404 94.5111C64.9106 93.7333 64.6957 92.8778 64.6957 91.9444V74.0556C64.6957 73.1222 64.9106 72.2796 65.3404 71.5278C65.7954 70.75 66.3895 70.1407 67.1227 69.7C67.8812 69.2333 68.7155 69 69.6256 69H87.0321C87.9423 69 88.7766 69.2333 89.535 69.7C90.2935 70.1407 90.8876 70.75 91.3174 71.5278C91.7725 72.2796 92 73.1222 92 74.0556V75.7278H87.8664V74.1722C87.8664 73.913 87.7779 73.6926 87.601 73.5111C87.424 73.3037 87.2091 73.2 86.9563 73.2H69.7394C69.4866 73.2 69.259 73.3037 69.0568 73.5111C68.8798 73.6926 68.7913 73.913 68.7913 74.1722V91.8278C68.7913 92.087 68.8798 92.3204 69.0568 92.5278C69.259 92.7093 69.4866 92.8 69.7394 92.8H86.9563C87.2091 92.8 87.424 92.7093 87.601 92.5278C87.7779 92.3204 87.8664 92.087 87.8664 91.8278V85.8778H81.4196V81.6389H92V91.9444C92 92.8778 91.7725 93.7333 91.3174 94.5111C90.8876 95.263 90.2935 95.8722 89.535 96.3389C88.7766 96.7796 87.9423 97 87.0321 97H69.6256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6774_1174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 49L22.1094 61H74C83.9411 61 92 52.9411 92 43V1H20C10.0589 1 2 9.05888 2 19V61H22V49H14V21C14 16.5817 17.5817 13 22 13H80V41C80 45.4183 76.4183 49 72 49H36Z",
    fill: "url(#paint0_linear_6774_1174)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_6774_1174",
    x: 2,
    y: 0,
    width: 90,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6774_1174"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_6774_1174",
    result: "effect2_innerShadow_6774_1174"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6774_1174",
    x: 0,
    y: 0,
    width: 94,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6774_1174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6774_1174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6774_1174",
    x1: 63.65,
    y1: 1,
    x2: 7.9003,
    y2: 66.0562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03A9F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48AB17"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNew);
export default __webpack_public_path__ + "static/media/logo_new.323707e2.svg";
export { ForwardRef as ReactComponent };